import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Grid } from '@mui/material';
import { useGetAllJobsMutation } from '../../API/GetAllJobs';
import { JobCard } from '../../Common';
import { getJobsByFilters } from '../../Constants';
import './jobList.css';

const JobsList = () => {
  let offset = 0;
  const [getAllJobs, { data, isLoading }] = useGetAllJobsMutation();
  const [jobs, setJobs] = useState([]);

  const { Roles, Experience, jobType, basePay } = useSelector((state) => state.common);

  useEffect(() => {
    fetchData();
    return () => setJobs([])
  }, []);

  useEffect(() => {
    if (!Roles?.length && !Experience && !jobType.length && !basePay) {
      getAllJobs(0);
      setJobs(data?.jdList);
    } else {
      const filteredJobs = getJobsByFilters({ jobs, filters: { Roles, Experience, jobType, basePay } });
      setJobs(filteredJobs);
    }
  }, [Roles, Experience, jobType, basePay])

  const fetchData = () => {
    try {
      getAllJobs(offset)
        .then(response => response?.data?.jdList)
        .then(newData => {
          setJobs(prevData => prevData ? [...prevData, ...newData] : [...newData]);
          offset++;
        })
        .catch(error => console.error('Error fetching data:', error));
    } catch (error) {
      console.error('Error fetching data:', error)
    }
  };

  const handleScroll = () => {
    const { scrollTop, clientHeight, scrollHeight } =
      document.documentElement;
    if (scrollTop + clientHeight >= scrollHeight - 20) {
      fetchData();
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      setJobs([]);
    }
  }, []);

  return (
    <Grid container className='jobs-list' spacing={3} sx={{ maxWidth: '100%' }}>
      <Grid item xs={12} sx={{ padding: '24px 0 0 24px' }}>
        <Grid container className='grid-container' spacing={3} sx={{ marginX: 'auto' }}>
          {jobs?.length > 0
            ? jobs?.map((i) => (
              <Grid key={i?.jdUid} className='grid-item' item xs={12} md={6} lg={4}>
                <JobCard item={i} />
              </Grid>
            )) : (!isLoading &&
              <Grid className='no-data' item xs={12}>
                No Data.
              </Grid>
            )
          }
          {isLoading && (
            <Grid className='grid-item' item xs={12}>
              Loading...
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  )
}

export default JobsList;
